import React from 'react';

export default function Form({
    dateOfBirthPicker,
    emailFields,
    loginModal,
    nameFields,
    onSubmit,
    passwordModal,
    sexPicker,
    submitButton,
    termsAndPrivacy,
    title,
}) {
    return (
        <React.Fragment>
            {title}
            {loginModal}
            <form
                data-test="create-account-form"
                method="post"
                onSubmit={onSubmit}
            >
                {nameFields}
                {emailFields}
                {dateOfBirthPicker}
                {sexPicker}
                {termsAndPrivacy}
                {submitButton}
                {passwordModal}
            </form>
        </React.Fragment>
    );
}
